import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { FormlyFieldProps } from '../form-field/form-field-wrapper.component';

interface IconWrapperProps extends FormlyFieldProps {
  icon: string;
}

@Component({
  selector: 'kon-field-icon-wrapper',
  imports: [CommonModule, FormlyModule, InputIconModule, IconFieldModule],
  template: `
    <div class="p-field flex flex-col mb-4">
      <p-iconfield>
        <ng-container #fieldComponent></ng-container>
        <p-inputicon
          class="z-10 {{ props.icon }} self-center pt-1"
          [ngClass]="{ 'group-hover:invisible': this.field.type === 'number' }"
          />
      </p-iconfield>
      @if (showError) {
        <small class="p-error">
          <formly-validation-message
            class="ui-message-text"
            [field]="field"
          ></formly-validation-message>
        </small>
      }
    
      @if (props.description) {
        <small class="p-help">
          {{ props.description }}
        </small>
      }
    </div>
    `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldIconWrapperComponent extends FieldWrapper<
  FormlyFieldConfig<IconWrapperProps>
> {}
